var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"disabled":_vm.campoDesabilitado,"required":_vm.campoObrigatorio,"rules":[_vm.rules.requiredTime],"counter":_vm.maxCaracteres,"maxlength":_vm.maxCaracteres},on:{"input":_vm.emiteValorAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoTexto.vue?vue&type=template&id=74adf081&
// module id = 1331
// module chunks = 28